import { render, staticRenderFns } from "./Insurances.vue?vue&type=template&id=7962916c&scoped=true&"
import script from "./Insurances.vue?vue&type=script&lang=js&"
export * from "./Insurances.vue?vue&type=script&lang=js&"
import style0 from "./Insurances.vue?vue&type=style&index=0&id=7962916c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7962916c",
  null
  
)

export default component.exports